import Vue from "vue";

import JQuery from "jquery";
window.$ = JQuery;

import VueMeta from "vue-meta";

import axios from "axios";
import Notifications from "vue-notification";
import DatetimePicker from "vuetify-datetime-picker";

import App from "./components/App.vue";
import moment from "moment";

import Vuetify from "vuetify";
import router from "./router/index";
import store from "./store/index";
import "./config/http";
import VueTheMask from "vue-the-mask";
import Vue2Filters from "vue2-filters";
import VuetifyMoney from "vuetify-money";
import "vuetify/dist/vuetify.min.css";
import * as VueGoogleMaps from "vue2-google-maps";
import VueCookies from "vue-cookies";
import VueTour from "vue-tour";
import "vue-tour/dist/vue-tour.css";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import Vuelidate from "vuelidate";
import VueSignaturePad from "vue-signature-pad";

window.Lang = require("lang.js");
window.Pusher = require("pusher-js");

// get the data source
require("../assets/js/vue-translations.js");

// this is why we used the --no-lib in our commandline
window.lang = window.Lang;
const lang = window.lang;
lang.setLocale("en");
lang.setFallback("en");

// This is our normal Vue filter. '...args' allows us to use any
// number of parameters in our strings
Vue.filter("trans", (...args) => {
    return lang.get(...args);
});

Vue.filter("toCurrency", (value) => {
    if (typeof value === "string") {
        value = parseFloat(value || 0);
    }
    if (lang.getLocale() === "pt") {
        var formatter = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
        });
        return formatter.format(value || 0);
    }
    var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    });
    return formatter.format(value || 0);
});

Vue.use(VueTour);
Vue.use(Notifications);
Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(DatetimePicker);
Vue.use(VueMeta);
Vue.use(VueCookies);
Vue.use(VueTheMask);
Vue.use(Vue2Filters);
Vue.use(VuetifyMoney);
Vue.use(VueTelInput);
Vue.use(Vuelidate);
Vue.use(VueSignaturePad);

Vue.use(VueGoogleMaps, {
    load: {
        key: mapApiKey,
    },
});

Vue.mixin({
    data() {
        return {
            appName: app_name,
        };
    },
    methods: {
        canAccess: (action, user, exceptSuperAdmin = true) => {
            if (!action || !user) return false;
            if (exceptSuperAdmin && user.origin_role == "super_admin")
                return true;

            return user.access && user.access.includes(action) ? true : false;
        },
        currency: (
            amount = 0.0,
            locale_str = "en-US",
            format_str = "USD",
            useGrouping = false
        ) => {
            return Intl.NumberFormat(locale_str, {
                style: "currency",
                currency: format_str,
                useGrouping: useGrouping,
            }).format(amount);
        },
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                return moment(String(value)).format("DD-MMM-YYYY");
            }
        },
        formatDateTime: function (date, format = "DD-MMM-YYYY hh:mm:ss") {
            if (date && date.includes("T")) {
                return moment(String(date), moment.ISO_8601).format(format);
            }
            if (date) {
                return date;
                 //   return moment(date, "DD-MM-YYYY hh:mm:ss").isValid()
                //  ? moment(date, "DD-MM-YYYY hh:mm:ss").format(format)
                //   : date;
            }
        },
    },
});

// Set axios default header
axios.defaults.headers["X-CSRF-Token"] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content");
axios.defaults.headers["Content-Type"] = "application/json";

new Vue({
    router,
    store,
    metaInfo: {
        titleTemplate: (title) =>
            title ? `${title} - ${app_name}` : `${app_name}`,
    },
    vuetify: new Vuetify({
        theme: {
            dark: window.matchMedia("(prefers-color-scheme: dark)").matches,
            themes: {
                light: {
                    background: 'var(--v-background)',
                    titles: '#4b4b5a',
                    purewhite: '#fff',
                    pureblack:'#000',
                  },
                dark: {
                    background: '#1e1e1e',
                    titles: '#1e1e1e',
                    purewhite: '#000',
                    pureblack: '#272727',
                }
            },
            customProperties: true
        },
    }),
    render: (h) => h(App),
}).$mount("#app");
